<div class="locked-staking-disclaimer wrapper">
	<div class="image">
		<svg-inline src="assets/images/staking/locked-staking.svg" alt="locked-staking" />
	</div>
	<div class="content">
		<div class="title">{{ "locked_staking_eth_intro_modal_title" | translate }}</div>
		<div class="description">{{ "locked_staking_eth_intro_modal_description" | translate }}</div>
	</div>
	<div class="buttons">
		<bp-button (click)="onButtonClick.emit()" fluid size="large" variant="primary">{{
			"save_and_continue" | translate
		}}</bp-button>
		<bp-button (click)="openLink()" fluid size="large" variant="secondary">{{
			"more_information" | translate
		}}</bp-button>
	</div>
</div>
